import { useTranslation } from "react-i18next";
import PreferredLanguageInfo from "../../../../../../../components/ABOProfile/InfoComponents/PreferredLanguageInfo/PreferredLanguageInfo";
import RecentReturnDateInfo from "../../../../../../../components/ABOProfile/InfoComponents/RecentReturnDateInfo/RecentReturnDateInfo";
import RecentOrderDateInfo from "../../../../../../../components/ABOProfile/InfoComponents/RecentOrderDateInfo/RecentOrderDateInfo";
import RenewalDateInfo from "../../../../../../../components/ABOProfile/InfoComponents/RenewalDateInfo/RenewalDateInfo";
import DateJoinedInfo from "../../../../../../../components/ABOProfile/InfoComponents/DateJoinedInfo/DateJoinedInfo";
import BirthdayInfo from "../../../../../../../components/ABOProfile/InfoComponents/BirthdayInfo/BirthdayInfo";
import defaultContent from "../../../../../../../content/profile";
import { useAppSelector } from "../../../../../../../store";
import "./CustomerAdditionalInfo.scss";

type Props = {
  privacyFlag: boolean;
  recentOrderDate: string;
  recentReturnDate: string;
  isoLanguageCode: string;
  isoBirthdate: string;
  entryDate: string;
  renewalDate: string;
};

const CustomerAdditionalInfo = (props: Props) => {
  const { t } = useTranslation(["profile"]);
  const { privacyFlag, recentOrderDate, recentReturnDate, isoLanguageCode, isoBirthdate, entryDate, renewalDate } =
    props;

  const boot = useAppSelector(({ boot }) => boot);

  const { showBirthday, showEntryDate, showLanguage, showRecentOrderDate, showRecentReturnOrderDate, showRenewalDate } =
    boot?.configuration?.profile?.customerInfo || {};

  return (
    <div className="customer-additional-info__container">
      <div className="customer-additional-info__header">
        {`${t(
          "customerProfile.profileTab.additionalInformation",
          defaultContent["customerProfile"]["profileTab"]["additionalInformation"],
        )}`}
      </div>
      <div className="customer-additional-info__content">
        <RecentOrderDateInfo date={recentOrderDate} privacyFlag={privacyFlag} show={showRecentOrderDate} />
        <RecentReturnDateInfo date={recentReturnDate} privacyFlag={privacyFlag} show={showRecentReturnOrderDate} />
        <PreferredLanguageInfo isoLanguage={isoLanguageCode} privacyFlag={privacyFlag} show={showLanguage} />
        <BirthdayInfo date={isoBirthdate} privacyFlag={privacyFlag} show={showBirthday} />
        <DateJoinedInfo date={entryDate} privacyFlag={privacyFlag} show={showEntryDate} />
        <RenewalDateInfo date={renewalDate} privacyFlag={privacyFlag} show={showRenewalDate} />
      </div>
    </div>
  );
};

export default CustomerAdditionalInfo;
